
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import financialService from '../../services/financialService';

const DepositCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('Verifying payment...');

    useEffect(() => {
        const verify = async () => {
            const provider = searchParams.get('provider');
            const token = searchParams.get('token'); // PayPal Order ID

            if (provider === 'paypal' && token) {
                try {
                    setStatus('Capturing secure payment...');
                    await financialService.capturePayPalOrder(token);
                    setStatus('Success! Redirecting...');
                    setTimeout(() => navigate('/financial'), 2000);
                } catch (err) {
                    setStatus('Payment Failed: ' + (err as any).message);
                }
            } else if (provider === 'coinbase') {
                // Coinbase handling is simpler for callback, usually just close window or show pending
                setStatus('Crypto payment initiated. Funds will appear after blockchain confirmation.');
                setTimeout(() => navigate('/financial'), 4000);
            } else {
                setStatus('Invalid callback parameters.');
            }
        };

        verify();
    }, [searchParams, navigate]);

    return (
        <div className="min-h-screen bg-premium-wood-dark flex items-center justify-center text-white">
            <div className="text-center p-8 bg-black/20 rounded-xl border border-premium-gold/30">
                <h2 className="text-2xl font-serif text-premium-gold mb-4">{status}</h2>
                <div className="w-8 h-8 border-4 border-premium-gold border-t-transparent rounded-full animate-spin mx-auto"></div>
            </div>
        </div>
    );
};

export default DepositCallback;
